import React from "react";
import { Box, BoxProps, SxProps, Theme, useTheme } from "@mui/material";
import { getAccentGradient } from "../../constants/gradient";

type DividerGradientProps = BoxProps & {
  height?: number;
  width?: string | number;
  gradientAngle?: string;
  orientation?: "horizontal" | "vertical";
  sx?: SxProps<Theme>;
};

/**
 * Reusable Divider component with gradient styling
 * Useful for section separators and accent lines
 */
const DividerGradient: React.FC<DividerGradientProps> = ({
  height = 3,
  width = "100%",
  gradientAngle = "90deg",
  orientation = "horizontal",
  sx,
  ...props
}) => {
  const theme = useTheme();
  const gradient = getAccentGradient(theme, gradientAngle);

  return (
    <Box
      {...props}
      sx={[
        {
          backgroundImage: gradient,
          borderRadius: height / 2,
          ...(orientation === "horizontal"
            ? {
                width,
                height,
              }
            : {
                height: width,
                width: height,
              }),
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  );
};

export default DividerGradient;

